<section
    class="flex flex-col w-[17.5rem] md:w-[23rem] theme-wrapper theme-border rounded-md p-4 select-none bg-white"
>
    <ng-container *ngTemplateOutlet="header" />
    <ng-container *ngTemplateOutlet="daySection" />
</section>

<ng-template #header>
    <section
        class="relative flex w-full items-center justify-between mb-3 gap-2"
    >
        <app-calendar-label
            [value]="value()"
            (dateChange)="handleEvent($event)"
        />

        <div class="flex gap-3 items-center">
            <app-icon-button
                (click)="handleNavigate('prev', 'month', 1)"
                icon="ic:baseline-chevron-left"
            />
            <app-icon-button
                (click)="handleNavigate('next', 'month', 1)"
                icon="ic:baseline-chevron-right"
            />
        </div>
    </section>
</ng-template>

<ng-template #daySection>
    <section class="flex flex-col">
        <div class="grid grid-cols-7 w-full">
            <p class="item text-red-600">일</p>
            <p class="item">월</p>
            <p class="item">화</p>
            <p class="item">수</p>
            <p class="item">목</p>
            <p class="item">금</p>
            <p class="item text-blue-600">토</p>
        </div>
        <div class="grid grid-cols-7 w-full">
            @for (day of days(); track $index) {
                @if (mode() === "range") {
                    <app-range-day (select)="handleSelectDay()" [day]="day" />
                } @else {
                    <app-day
                        [maxDate]="maxDate()"
                        [minDate]="minDate()"
                        (select)="handleSelectDay()"
                        [day]="day"
                    />
                }
            }
        </div>
    </section>
</ng-template>
